import { Icon } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import AuthContext from '../../store/auth-context';
import { AccessibilityContext } from '../../store/accesibility-context';
import Switch from '@mui/material/Switch';

import './UserLink.scss';

const UserLink = () => {
	const navigate = useNavigate();
	const authCtx = useContext(AuthContext);
	const accessibilityCtx = useContext(AccessibilityContext);
	const logoutHandler = () => {
		authCtx.logout();
		navigate('/login');
	};
	const [showAccessibilityMenu, setShowAccessibilityMenu] =
		useState(false);

	const handleAccessibilityClick = () => {
		setShowAccessibilityMenu(true);
	};

	const handleBackClick = () => {
		setShowAccessibilityMenu(false);
	};

	return (
		<div className='user-link-container dropdown'>
			{/* TODO create user avatar component and get profile image from backend */}
			<icon
				data-bs-toggle='dropdown'
				data-bs-dismiss='dropdown'
				className='user-icon'
			>
				{authCtx.userData.capitals || ''}
			</icon>
			<span
				className='user-label'
				data-bs-toggle='dropdown'
				data-bs-dismiss='dropdown'
			>
				{authCtx.userData.firstname}
			</span>
			<Icon
				className='dropdown-toggle'
				data-bs-toggle='dropdown'
				data-bs-auto-close='outside'
			>
				chevron_right
			</Icon>
			{!showAccessibilityMenu ? (
				<div className='dropdown-menu'>
					<div className='user-item-list '>
						<ul className='user-items'>
							<li className='user-item'>
								<Icon>logout</Icon>
								<a onClick={logoutHandler} href='/'>
									Log out
								</a>
							</li>
							<li className='user-item'>
								<Icon>person</Icon>
								<a href='/user-profile'>My Profile</a>
							</li>
							<li className='user-item'>
								<div
									className='accessibility-button'
									data-bs-toggle='dropdown'
									data-bs-auto-close='outside'
									onClick={handleAccessibilityClick}
								>
									<Icon>accessibility</Icon>
									<span>Accessibility</span>
									<Icon className='dropdown-toggle'>
										chevron_right
									</Icon>
								</div>
							</li>
						</ul>
					</div>
				</div>
			) : (
				<div className='dropdown-menu'>
					<div className='item-container'>
						<Icon onClick={handleBackClick}>
							chevron_left
						</Icon>
						<span>Accessibility</span>
					</div>
					<div className='item-container'>
						<Icon>contrast</Icon>
						<span className='user-label'>Contrast</span>
						<Switch
							onChange={(event) =>
								accessibilityCtx.setContrast(
									event.target.checked
								)
							}
							checked={accessibilityCtx.contrast}
						/>
					</div>
					<div className='item-font-container'>
						<Icon>format_size</Icon>
						<span className='user-label'>Font Size</span>
						<Switch
							onChange={(event) =>
								accessibilityCtx.setFont_Size(
									event.target.checked
								)
							}
							checked={accessibilityCtx.font_Size}
						/>
					</div>
				</div>
			)}
		</div>
	);
};
export default UserLink;
